module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.users !== null) ? _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "user-manage"
    }
  }, [_c('table', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      staticClass: "grid"
    }, [_c('td', {
      staticClass: "col-1"
    }, [_vm._v(_vm._s(user.uid))]), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_vm._v(_vm._s(user.mail))]), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_c('router-link', {
      attrs: {
        "to": ("/profile/" + (user.uid) + "/")
      }
    }, [_vm._v(_vm._s(user.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "col-2"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.level),
        expression: "user.level"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          user.level = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("Kernel")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("User")])])]), _vm._v(" "), _c('td', {
      staticClass: "col-2"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.category),
        expression: "user.category"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          user.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("Universe")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("Algo")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("CLang")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("PyLang")])])]), _vm._v(" "), _c('td', {
      staticClass: "col-1"
    }, [_c('div', {
      staticClass: "grid grid-noGutter"
    }, [_c('div', {
      staticClass: "col",
      attrs: {
        "title": "Apply"
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onApplyUser(user)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col",
      attrs: {
        "title": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onRemoveUser(user)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col",
      attrs: {
        "title": "Login"
      }
    }, [_c('i', {
      staticClass: "fa fa-sign-in btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onLoginUser(user)
        }
      }
    })])])])])
  })], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col-1"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Mail")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "col-2"
  }, [_vm._v("Level")]), _vm._v(" "), _c('th', {
    staticClass: "col-2"
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', {
    staticClass: "col-1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1cb2182"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserManage.vue
// module id = 590
// module chunks = 0